import { Button, Drawer } from 'antd'
import React, { useState } from 'react'
import HomeItems from '../pages/Synopsis/HomeItems'
import Item0 from '../assets/homenavigation.png'
import CloseBtn from '../assets/closeBtn.png'
import { CloseOutlined } from '@ant-design/icons'

function HomeNavigationDrawer() {
  const [leftValue, setLeftValue] = useState(0)
  const [open, setOpen] = useState(false)
  const showDrawer = () => {
    setOpen(true)
    setLeftValue(370)
  }
  const onClose = () => {
    setOpen(false)
    setLeftValue(0)
  }

  return (
    <div>
      <Button
        size={'large'}
        style={{
          position: 'absolute',
          left: leftValue,
          zIndex: 2,
          padding: 2,
          height: 60,
          borderTopRightRadius: 15,
          borderBottomRightRadius: 15,
          background: '#051422',
          transition: '0.2 ease-in',
          border: 'none',
        }}
        onClick={showDrawer}
      >
        <img
          src={open == true ? CloseBtn : Item0}
          alt='icon'
          style={
            open == true
              ? {
                  width: '2.5rem',
                  height: '2.5rem',
                  marginLeft: 5,
                  marginRight: 5,
                  cursor: 'pointer',
                }
              : { width: '2rem', height: '2rem', cursor: 'pointer' }
          }
        />
      </Button>
      <Drawer
        className='HomeDrawer'
        headerStyle={{
          background: '#051422',
          borderBottom: '#051422',
        }}
        bodyStyle={{
          background: '#051422',
          overflow: 'auto',
        }}
        placement='left'
        onClose={onClose}
        open={open}
        closeIcon={<CloseOutlined style={{ color: '#FFF' }} />}
      >
        <HomeItems />
      </Drawer>
    </div>
  )
}

export default HomeNavigationDrawer
